import { globalConstants } from "../constants";
import { getRequest, putRequest } from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getRefundPolicyData() {
  return getRequest(`/${globalConstants.VERSION}/RefundType/all`, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateFundPolicyTypes(data) {
  return putRequest(
    `/${globalConstants.VERSION}/RefundType`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const refundPolicyService = {
  getRefundPolicyData,
  updateFundPolicyTypes
};
